// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header[data-v-cf6ae3a0] {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 0 0 0;
  gap: 8px;
}
.main-header[data-v-cf6ae3a0] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.sub-header[data-v-cf6ae3a0] {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 14px;
  width: 100%;
  padding: 4px 0 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.app-header-left[data-v-cf6ae3a0] {
  display: flex;
  align-items: baseline;
  gap: 14px;
  min-width: 0;
}
[data-v-cf6ae3a0] .app-header-brand-link {
  text-decoration: none;
  color: inherit;
  outline: none;
}
[data-v-cf6ae3a0] .app-header-brand-link:focus-visible .app-header-brand {
  text-decoration: underline;
}
.app-header-brand[data-v-cf6ae3a0] {
  margin: 0;
  font-family: "Starjedi", "TradeGothic", sans-serif;
  font-weight: bold;
  font-size: 32px;
  line-height: 1;
  color: yellow;
  white-space: nowrap;
}
.app-header-nav[data-v-cf6ae3a0] {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 18px;
  margin-left: 4px;
}
[data-v-cf6ae3a0] .app-header-nav-link {
  font-family: "Starjedi", "TradeGothic", sans-serif;
  font-size: 20px;
  letter-spacing: 0.04em;
  text-transform: lowercase;
  color: yellow;
  text-decoration: none;
  white-space: nowrap;
  outline: none;
}
[data-v-cf6ae3a0] .app-header-nav-link:hover,[data-v-cf6ae3a0] .app-header-nav-link:focus-visible {
  text-decoration: underline;
}
[data-v-cf6ae3a0] .app-header-nav-link-active {
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-thickness: 2px;
}
.app-header-menu-root[data-v-cf6ae3a0] {
  position: relative;
}
.app-header-menu-trigger[data-v-cf6ae3a0] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 0;
  background: transparent;
  color: yellow;
  cursor: pointer;
  padding: 0;
  overflow: hidden;
}
.app-header-menu-gif[data-v-cf6ae3a0] {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.app-header-menu[data-v-cf6ae3a0] {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 10;
  min-width: 160px;
  background: black;
  border: 1px solid yellow;
  border-radius: 4px;
  list-style: none;
  margin: 0;
  padding: 4px 0;
}
.app-header-menu-item[data-v-cf6ae3a0] {
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  padding: 8px 12px;
  color: yellow;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
}
.app-header-menu-item[data-v-cf6ae3a0]:hover {
  background: rgba(255, 255, 0, 0.15);
}
.visually-hidden[data-v-cf6ae3a0] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/AppHeader.vue","webpack://./AppHeader.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACE,mBAAA;EACF,QAAA;ACDF;ADIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;ACDF;ADIA;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;EACA,kDAAA;ACDF;ADIA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,YAAA;ACDF;ADIA;EACE,qBAAA;EACA,cAAA;EACA,aAAA;ACDF;ADIA;EACE,0BAAA;ACDF;ADIA;EACE,SAAA;EACA,kDAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;ACDF;ADIA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;ACDF;ADIA;EACE,kDAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;ACDF;ADIA;EAEE,0BAAA;ACDF;ADIA;EACE,0BAAA;EACA,0BAAA;EACA,8BAAA;ACDF;ADIA;EACE,kBAAA;ACDF;ADIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACE,SAAA;EACF,uBAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;ACDF;ADIA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;ACDF;ADIA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;ACDF;ADIA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;ACDF;ADIA;EACE,mCAAA;ACDF;ADIA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.app-header {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n    padding: 24px 0 0 0;\n  gap: 8px;\n}\n\n.main-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.sub-header {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 14px;\n  width: 100%;\n  padding: 4px 0 8px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.app-header-left {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  min-width: 0;\n}\n\n:deep(.app-header-brand-link) {\n  text-decoration: none;\n  color: inherit;\n  outline: none;\n}\n\n:deep(.app-header-brand-link:focus-visible) .app-header-brand {\n  text-decoration: underline;\n}\n\n.app-header-brand {\n  margin: 0;\n  font-family: 'Starjedi', 'TradeGothic', sans-serif;\n  font-weight: bold;\n  font-size: 32px;\n  line-height: 1;\n  color: yellow;\n  white-space: nowrap;\n}\n\n.app-header-nav {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 18px;\n  margin-left: 4px;\n}\n\n:deep(.app-header-nav-link) {\n  font-family: 'Starjedi', 'TradeGothic', sans-serif;\n  font-size: 20px;\n  letter-spacing: 0.04em;\n  text-transform: lowercase;\n  color: yellow;\n  text-decoration: none;\n  white-space: nowrap;\n  outline: none;\n}\n\n:deep(.app-header-nav-link:hover),\n:deep(.app-header-nav-link:focus-visible) {\n  text-decoration: underline;\n}\n\n:deep(.app-header-nav-link-active) {\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  text-decoration-thickness: 2px;\n}\n\n.app-header-menu-root {\n  position: relative;\n}\n\n.app-header-menu-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n    border: 0;\n  background: transparent;\n  color: yellow;\n  cursor: pointer;\n  padding: 0;\n  overflow: hidden;\n}\n\n.app-header-menu-gif {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.app-header-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 10;\n  min-width: 160px;\n  background: black;\n  border: 1px solid yellow;\n  border-radius: 4px;\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n}\n\n.app-header-menu-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  padding: 8px 12px;\n  color: yellow;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n}\n\n.app-header-menu-item:hover {\n  background: rgba(255, 255, 0, 0.15);\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n",".app-header {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 24px 0 0 0;\n  gap: 8px;\n}\n\n.main-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.sub-header {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 14px;\n  width: 100%;\n  padding: 4px 0 8px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.app-header-left {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  min-width: 0;\n}\n\n:deep(.app-header-brand-link) {\n  text-decoration: none;\n  color: inherit;\n  outline: none;\n}\n\n:deep(.app-header-brand-link:focus-visible) .app-header-brand {\n  text-decoration: underline;\n}\n\n.app-header-brand {\n  margin: 0;\n  font-family: \"Starjedi\", \"TradeGothic\", sans-serif;\n  font-weight: bold;\n  font-size: 32px;\n  line-height: 1;\n  color: yellow;\n  white-space: nowrap;\n}\n\n.app-header-nav {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 18px;\n  margin-left: 4px;\n}\n\n:deep(.app-header-nav-link) {\n  font-family: \"Starjedi\", \"TradeGothic\", sans-serif;\n  font-size: 20px;\n  letter-spacing: 0.04em;\n  text-transform: lowercase;\n  color: yellow;\n  text-decoration: none;\n  white-space: nowrap;\n  outline: none;\n}\n\n:deep(.app-header-nav-link:hover),\n:deep(.app-header-nav-link:focus-visible) {\n  text-decoration: underline;\n}\n\n:deep(.app-header-nav-link-active) {\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  text-decoration-thickness: 2px;\n}\n\n.app-header-menu-root {\n  position: relative;\n}\n\n.app-header-menu-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 0;\n  background: transparent;\n  color: yellow;\n  cursor: pointer;\n  padding: 0;\n  overflow: hidden;\n}\n\n.app-header-menu-gif {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.app-header-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 10;\n  min-width: 160px;\n  background: black;\n  border: 1px solid yellow;\n  border-radius: 4px;\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n}\n\n.app-header-menu-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border: 0;\n  padding: 8px 12px;\n  color: yellow;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n}\n\n.app-header-menu-item:hover {\n  background: rgba(255, 255, 0, 0.15);\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
